module.exports = __webpack_public_path__ + "static/media/dealB.61151395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/dealB.svg
// module id = 559
// module chunks = 0